import {
    pageDefaultMenu,
    pageDefaultMenuBtn
} from "./_selectors";

const handleClick = () => {
    pageDefaultMenu.classList.toggle('--open');
}

pageDefaultMenuBtn?.addEventListener('click', handleClick)
